import { render, staticRenderFns } from "./studentTagTopBar.vue?vue&type=template&id=4327b55e&scoped=true"
import script from "./studentTagTopBar.vue?vue&type=script&lang=js"
export * from "./studentTagTopBar.vue?vue&type=script&lang=js"
import style0 from "./studentTagTopBar.vue?vue&type=style&index=0&id=4327b55e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4327b55e",
  null
  
)

export default component.exports